export default __webpack_public_path__ + "static/media/logo.0b5545d6.webp";